import { isPGS, isWhatuni } from "./commonFunction";

export interface EnquiryDetailsLike {
  websiteFlag?: string;
  callNowFlag?: string;
  website?: string;
  hotLineNo?: string;
  openday_flag?: string; // sometimes used with underscore
  opendayFlag?: string;  // fallback camelCase variant
  prospectusFlag?: string;
  emailFlag?: string;
  applyNowFlag?: string;
}

interface ExtendedEnquiryDetails extends EnquiryDetailsLike {
  recommendedUni?: string;
}


/**
 * Returns the number of visible CTA buttons for the header based on enquiry details and project.
 * Project rules:
 * - whatuni: exclude applyNowFlag
 * - pgs: exclude prospectusFlag
 */
export function getHeaderCtaCount(enquiryDetails?: ExtendedEnquiryDetails): number {
  if (!enquiryDetails) return 0;

  const flagEntries: Array<[key: string, value: string | undefined]> = [
    ["applyNowFlag", enquiryDetails.applyNowFlag],
    ["emailFlag", enquiryDetails.emailFlag],
    // Support both openday_flag and opendayFlag
    ["opendayFlag", enquiryDetails.opendayFlag ?? enquiryDetails.openday_flag],
    ["callNowFlag", enquiryDetails.callNowFlag],
    ["websiteFlag", enquiryDetails.websiteFlag],
    ["prospectusFlag", enquiryDetails.prospectusFlag],
    ["recommendedUni", enquiryDetails.recommendedUni]
  ];

  const filtered = flagEntries.filter(([key]) => {
    if (isWhatuni() && key === "applyNowFlag") return false;
    if (isPGS() && key === "prospectusFlag") return false;
    return true;
  });

  const count = filtered.reduce((accumulator, [, value]) => {
    return (value || "").toLowerCase() === "y" ? accumulator + 1 : accumulator;
  }, 0);

  return count;
}


